<template>
	<card class="information-card">
		<card-header v-if="title || $slots.title">
			<div class="tw-p-6 uppercase text-primary font-weight-bold tw-text-center">
				{{ title }}
				<slot name="title"></slot>
			</div>
		</card-header>
		<card-sub-header v-if="subTitle">
			<div class="tw-px-4 tw-py-4 uppercase tw-text-center text-secondary" >
				{{ subTitle }}
			</div>
		</card-sub-header>
		<div class="information-card-header">
		</div>
		<div class="information-card-content text-info tw-p-4">
			<slot name="content" />
		</div>
		<card-footer>
			<div class="information-card-footer tw-pt-6">
				<slot name="footer" />
			</div>
		</card-footer>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import CardFooter from '@/modules/shared/components/ui/Card/CardFooter';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import CardSubHeader from '@/modules/shared/components/ui/Card/CardSubHeader';

export default {
	name: 'InformationCard',
	components: { CardSubHeader, CardHeader, CardFooter, Card },
	props: ['title', 'subTitle', 'description'],
};
</script>

<style lang="scss" scoped>
.information-card {
	.information-card-content {
		min-height: 500px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/content/InformationCard.vue